import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from '@angular/forms';
import { ColumnDefinition } from './grid.interface';
import { GridOptions } from './grid.interface';
import { InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';
import { has } from '@tmhcc/util';
@Injectable({
  providedIn: 'root'
})
export class CustomService {
  constructor(private fb: FormBuilder) {}

  tableRows: FormArray;

  initForm() {
    return this.fb.group({
      tableRows: this.fb.array([])
    });
  }

  defaultInitialRow(columnsSetting: Array<ColumnDefinition>) {
    return this.fb.group({
      tableRows: this.fb.array([this.createRowItem(columnsSetting)])
    });
  }

  createRowItem(columnsSetting: Array<InputConfig>): FormGroup {
    const group = {};
    columnsSetting.forEach(input_template => {
      let validators;
      if (input_template.config && input_template.config.validation) {
        validators = input_template.config.validation;
      } else {
        validators = null;
      }
      group[input_template.fieldInfo.fieldName] = new FormControl(
        '',
        Validators.compose(validators)
      );
    });
    return this.fb.group(group);
  }

  populateExistItem(rowItem, columnsSetting: Array<InputConfig>) {
    const group = {};
    Object.keys(rowItem).forEach((input, index) => {
      columnsSetting.forEach(column => {
        if (input == column.fieldInfo.fieldName) {
          let validators;
          if (column.config && column.config.validation) {
            validators = column.config.validation;
          } else {
            validators = null;
          }
          let chkDependency;
          if (has(column, 'dependency')) {
            if (has(column.dependency, 'parentControl')) {
              if (rowItem[column.dependency.parentControl]) {
                chkDependency = false;
              } else {
                chkDependency = true;
              }
            }
          }
          group[input] = new FormControl(
            has(column, 'dependency')
              ? {
                  value: Object.values(rowItem)[index],
                  disabled: chkDependency
                }
              : Object.values(rowItem)[index],
            Validators.compose(validators)
          );
        }
      });
      //group[input] = new FormControl(Object.values(rowItem)[index]);
    });
    return this.fb.group(group);
  }

  normalTableOptions() {
    return {
      pagingType: 'full_numbers',
      autoWidth: false,
      lengthChange: false,
      searching: false,
      processing: true
    };
  }

  inputTableOptions(paging = true) {
    return {
      pagingType: 'full_numbers',
      autoWidth: false,
      paginate: paging,
      language: {
        emptyTable: '',
        zeroRecords: 'No Related Record Found',
        paginate: {
          previous: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          next: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
          first: '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
          last: '<i class="fa fa-angle-double-right" aria-hidden="true"></i>'
        }
      },
      searching: false,
      lengthChange: false,
      ordering: false,
      info: false,
      dom: '<lf<"table-responsive"t>ip>'
    };
  }

  setGridDataOptionsForVisibility(inputSetting: GridOptions, divId) {
    let state: string;
    return {
      pagingType: 'full_numbers',
      autoWidth: false,
      language: {
        emptyTable: '',
        zeroRecords: 'No Related Record Found',
        paginate: {
          previous: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          next: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
          first: '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
          last: '<i class="fa fa-angle-double-right" aria-hidden="true"></i>'
        },
        search: '<i class="fa fa-search"></i>',
        searchPlaceholder: 'Search'
      },
      pageLength: inputSetting.pageLength ? inputSetting.pageLength : 10,
      lengthChange: false,
      searching: inputSetting.hasOwnProperty('searching')
        ? inputSetting.searching
        : false,
      info: false,
      processing: true,
      paging: inputSetting.hasOwnProperty('paging')
        ? inputSetting.paging
        : true,
      ordering: inputSetting.hasOwnProperty('ordering')
        ? inputSetting.ordering
        : true,
      dom: inputSetting.hasOwnProperty('isVisibility')
        ? this.domOptionForGrid(inputSetting.isVisibility)
        : this.domOptionForGrid(false),
      buttons: this.buttonsOptionForGrid(inputSetting),
      stateSave: true,
      stateSaveCallback: function(settings, data) {
        if (!localStorage.getItem(divId)) {
          state = 'DataTables_' + settings.sInstance + divId;
          localStorage.setItem(divId, state);
        } else {
          state = localStorage.getItem(divId);
        }
        if (
          data.hasOwnProperty('search') &&
          data.search.hasOwnProperty('search')
        ) {
          data.search.search = '';
        }
        localStorage.setItem(state, JSON.stringify(data));
      },
      stateLoadCallback: function(settings) {
        if (localStorage.getItem(divId)) {
          state = localStorage.getItem(divId);
        }
        return JSON.parse(localStorage.getItem(state));
      }
    };
  }

  setGridDataOptions(inputSetting: GridOptions) {
    return {
      pagingType: 'full_numbers',
      autoWidth: false,
      language: {
        emptyTable: '',
        zeroRecords: 'No Related Record Found',
        paginate: {
          previous: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          next: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
          first: '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
          last: '<i class="fa fa-angle-double-right" aria-hidden="true"></i>'
        },
        search: '<i class="fa fa-search"></i>',
        searchPlaceholder: 'Search'
      },
      pageLength: inputSetting.pageLength ? inputSetting.pageLength : 10,
      lengthChange: false,
      searching: inputSetting.hasOwnProperty('searching')
        ? inputSetting.searching
        : false,
      info: false,
      processing: true,
      paging: inputSetting.hasOwnProperty('paging')
        ? inputSetting.paging
        : true,
      ordering: inputSetting.hasOwnProperty('ordering')
        ? inputSetting.ordering
        : true,
      dom: inputSetting.hasOwnProperty('isVisibility')
        ? this.domOptionForGrid(inputSetting.isVisibility)
        : this.domOptionForGrid(false),
      buttons: this.buttonsOptionForGrid(inputSetting)
    };
  }

  domOptionForGrid(value) {
    return value
      ? '<"customBtnGrid"Br>' + '<lf<"table-responsive"t>ip>'
      : '<lf<"table-responsive"t>ip>';
  }

  buttonsOptionForGrid(inputSetting: GridOptions) {
    const gridButtonOptions = [];
    if (
      inputSetting.hasOwnProperty('isVisibility') &&
      inputSetting.isVisibility
    ) {
      gridButtonOptions.push({ extend: 'colvis', text: 'Columns' });
    }
    if (
      inputSetting.hasOwnProperty('allowExcelExport') &&
      inputSetting.allowExcelExport
    ) {
      gridButtonOptions.push({
        extend: 'csvHtml5',
        text: '<i class="fa fa-file-excel-o"></i>',
        title: inputSetting.gridName
      });
    }
    if (
      inputSetting.hasOwnProperty('allowPdfExport') &&
      inputSetting.allowPdfExport
    ) {
      gridButtonOptions.push({
        extend: 'pdf',
        text: '<i class="fa fa-file-pdf-o"></i>',
        title: inputSetting.gridName
      });
    }
    return gridButtonOptions;
  }
}
